

    <section>
      <h3>Test Workflow</h3>
      <p>Please provide the input details to test the workflow.</p>
      <ui-type-interface-form *ngIf="initialized" [typeData]="typeData" (formSubmit)="onFormSubmit($event)"
                              #interfaceForm>

        <br/><br/>
        <button class="btn btn-outline-success btn-sm float-right" [disabled]="!interfaceForm.valid">Test</button>

      </ui-type-interface-form>
    </section>
  


// WEBPACK FOOTER //
// ./src/library/designer/workflow-designer-test.component.ts.WorkflowDesignerTestComponent.html